/* 页面模板分组下 路由集合 */

import Layout from '@/layout'

export const Templates = [
  {
    path: '/ListWithDrawer',
    component: Layout,
    redirect: '/ListWithDrawer/index',
    children: [
      {
        path: 'index',
        name: 'template_ListWithDrawer',
        component: () => import('@/pageComponents/ListWithDrawer/index'),
        meta: {
          title: '列表和抽屉',
          icon: 'dashboard-fill',
        },
      },
    ],
  },
  {
    path: '/tabList',
    component: Layout,
    redirect: '/tabList/index',
    meta: {
      title: 'tab列表',
      icon: 'dashboard-fill',
    },
    children: [
      {
        path: 'index',
        name: 'template_tabList',
        component: () => import('@/pageComponents/TabList/index'),
        meta: {
          title: '基础',
          icon: '',
        },
      },
      {
        path: 'tabList_main',
        name: 'template_tabList_main',
        hidden: true,
        component: () => import('@/pageComponents/TabList/index'),
        meta: {
          title: '路由关联切换',
          icon: '',
          tabUrl: true,
          tabArr: {
            1: '路由关联切换1',
            2: '路由关联切换2',
          },
        },
      },
      {
        path: 'tabList_main_tab_1',
        redirect: () => {
          return {
            path: '/tabList/tabList_main',
            query: {
              tab: '1',
            },
          }
        },
        name: 'template_TabList_main_tab_1',
        meta: {
          title: '路由关联切换1',
          icon: '',
        },
      },
      {
        path: 'tabList_main_tab_2',
        redirect: () => {
          return {
            path: '/tabList/tabList_main',
            query: {
              tab: '2',
            },
          }
        },
        name: 'template_TabList_main_tab_2',
        meta: {
          title: '路由关联切换2',
          icon: '',
        },
      },
    ],
  },
  {
    path: '/IconList',
    component: Layout,
    redirect: '/IconList/index',
    children: [
      {
        path: 'index',
        name: 'template_IconList',
        component: () => import('@/pageComponents/IconList/index'),
        meta: {
          title: '图标库',
          icon: 'dashboard-fill',
        },
      },
    ],
  },
]
